import { atom } from "jotai";

export const mobileSidebarOpenAtom = atom(false);
